import { syncAllSubDeptToTb, syncAllSubDeptStudentToTb, syncAllSubDeptTeacherToTb, getTbParentSyncLogPage, getTbParentSyncLog, getTbParentSyncLogDetailPage, deleteTbParentSyncLog, retryTbParentSyncFailed, getTbParentSyncRetryableDetailIds, getTbParentDetailPage, syncAllSubDeptParentToTb, deleteSubDeptStudentFromTb, deleteSubDeptTeacherFromTb, deleteSubDeptParentFromTb, clearLocalTbDeptIds, clearLocalTbStudentIds, clearLocalTbTeacherIds, clearLocalTbParentMappings, clearLocalTbDeptIdItem, clearLocalTbStudentIdItem, clearLocalTbTeacherIdItem, clearLocalTbParentMappingItem, deleteTbDeptItem, deleteTbStudentItem, deleteTbTeacherItem, deleteTbParentItem, syncTbDeptItem, syncTbStudentItem, syncTbTeacherItem, syncTbParentItem, getTbDeptSyncLogPage, getTbDeptSyncLog, getTbDeptSyncLogDetailPage, deleteTbDeptSyncLog, retryTbDeptSyncFailed, getTbDeptSyncRetryableDetailIds, getTbStudentSyncLogPage, getTbStudentSyncLog, getTbStudentSyncLogDetailPage, deleteTbStudentSyncLog, retryTbStudentSyncFailed, getTbStudentSyncRetryableDetailIds, getTbTeacherSyncLogPage, getTbTeacherSyncLog, getTbTeacherSyncLogDetailPage, deleteTbTeacherSyncLog, retryTbTeacherSyncFailed, getTbTeacherSyncRetryableDetailIds, getTbDeptDetailPage, getTbStudentDetailPage, getTbTeacherDetailPage, getTbParentStats } from '../../api/modules/department';

/** 天波批量同步冷却分钟数（与后端固定值一致）。创建于 2026-06-13 */
export const TB_SYNC_COOLDOWN_MINUTES = 5;

/** 部门组织类型中文映射 */
export const DEPT_ORG_TYPE_LABELS = {
  school: '学校',
  campus: '校区',
  period: '学段',
  grade: '年级',
  class: '班级',
  affiliateschool: '附属学校',
};

/** 部门组织类型转中文显示 */
export function formatDeptOrgTypeLabel(type) {
  if (type == null || type === '') return '';
  const key = String(type).toLowerCase();
  return DEPT_ORG_TYPE_LABELS[key] || type;
}

/** 实体 ID 列（学生/部门/教师） */
export const TB_SYNC_ENTITY_ID_PROPS = ['studentId', 'departmentId', 'teacherId', 'studentParentId'];

/** 天波平台 ID 列 */
export const TB_SYNC_TB_ID_PROPS = ['tbThirdPartId', 'tbStudentId', 'tbDeptId', 'tbTeacherId', 'tbParentId'];

export function isTbSyncEntityIdProp(prop) {
  return TB_SYNC_ENTITY_ID_PROPS.includes(prop);
}

export function isTbSyncTbIdProp(prop) {
  return TB_SYNC_TB_ID_PROPS.includes(prop);
}

export function formatTbSyncTbIdDisplay(val) {
  const num = Number(val);
  return num > 0 ? val : '';
}

export function formatTbSyncCellDisplay(val) {
  if (val == null) return '';
  return String(val).trim();
}

/** 同步明细跳过说明默认文案 */
export const TB_SYNC_SKIP_DEFAULT_MESSAGE = '所在部门未配置天波部门ID，已跳过';

export function formatTbSyncRemarkDisplay(row) {
  if (!row) return '';
  const msg = row.resultMessage;
  if (msg != null && msg !== '') return msg;
  const operation = String(row.operation || '');
  if (operation === '跳过') return TB_SYNC_SKIP_DEFAULT_MESSAGE;
  return '';
}

/** 明细表格列宽：仅用 minWidth，配合 el-table fit 按权重自动分配剩余宽度 */
export const TB_SYNC_STATUS_COL_MIN_WIDTH = 76;
export const TB_SYNC_RESULT_COL_MIN_WIDTH = 68;
export const TB_SYNC_REMARK_COL_MIN_WIDTH = 220;

/** 统计明细「同步状态」列（并入 statsDetailColumns 以保证表头表体对齐） */
export const TB_SYNC_STATS_STATUS_COLUMN = {
  prop: 'isSynced',
  label: '同步状态',
  minWidth: TB_SYNC_STATUS_COL_MIN_WIDTH,
  align: 'center',
  headerAlign: 'center',
  columnType: 'syncStatus',
};

export function buildStatsDetailColumns(columns) {
  return [...columns, TB_SYNC_STATS_STATUS_COLUMN];
}

/** 同步记录明细「结果 / 说明」列（并入 detailColumns 以保证表头表体对齐） */
export const TB_SYNC_LOG_RESULT_COLUMN = {
  prop: '_syncResult',
  label: '结果',
  minWidth: TB_SYNC_RESULT_COL_MIN_WIDTH,
  align: 'center',
  headerAlign: 'center',
  columnType: 'syncResult',
};

export const TB_SYNC_LOG_REMARK_COLUMN = {
  prop: 'resultMessage',
  label: '说明',
  minWidth: TB_SYNC_REMARK_COL_MIN_WIDTH,
  columnType: 'remark',
};

export function buildSyncLogDetailColumns(columns) {
  return [...columns, TB_SYNC_LOG_RESULT_COLUMN, TB_SYNC_LOG_REMARK_COLUMN];
}

/** 同步记录面板 UI 文案。创建于 2026-06-13 */
export const TB_SYNC_LOG_PANEL_UI = {
  recordId: '记录ID',
  status: '状态',
  success: '成功',
  fail: '失败',
  skip: '跳过',
  syncTime: '同步时间',
  triggerUser: '触发人',
  action: '操作',
  viewDetail: '查看明细',
  viewCountDetail: '点击查看明细',
  delete: '删除',
  loading: '正在加载汇总信息…',
  triggerUserLabel: '触发人：',
  syncTimeLabel: '同步时间：',
  all: '全部',
  onlySuccess: '仅成功',
  onlyFail: '仅失败',
  onlySkip: '仅跳过',
  refresh: '刷新',
  search: '搜索',
  result: '结果',
  remark: '说明',
  close: '关闭',
  deleteCurrent: '删除本条',
  detailDialogTitle: '同步记录明细',
  searchPlaceholderFallback: '关键词',
  statusRunning: '进行中',
  statusDone: '已完成',
  statusFailed: '失败',
  deleteConfirmTitle: '提示',
  deleteConfirmMessage: '确认删除同步记录 {nameHint}（编号 {id}）及其全部明细？',
  deletedMsg: '已删除',
  deleteFailedMsg: '删除失败',
  skipDetailLegacyHint: '本条记录仅有跳过汇总（{count} 条），未保存逐条明细；重新同步后可查看每位学生的跳过说明。',
  retrySelected: '重试选中',
  retryAllFailed: '重试全部失败',
  retryConfirmTitle: '失败重试',
  retryConfirmSelected: '将按当前最新数据重试选中的 {count} 条失败记录，确认继续吗？',
  retryConfirmAll: '将按当前最新数据重试本条记录下全部 {count} 条失败记录，确认继续吗？',
  retrySubmitted: '失败重试任务已提交',
  retryFailedMsg: '重试提交失败',
  retryDataHint: '提示：手机号、照片等数据错误需先在本地修正后再重试，否则仍会失败。',
  selectFilterAll: '全选当前筛选',
  retryCurrentFilter: '重试当前筛选',
  crossPageSelected: '已跨页选中 {count} 条',
  retryConfirmFilter: '将按当前最新数据重试筛选条件下的 {count} 条失败记录，确认继续吗？',
  noRetryableInFilter: '当前筛选条件下没有可重试的失败明细',
};

export const tbSyncApiMap = {
  dept: {
    label: '部门架构',
    deptColumnLabel: '部门',
    statsDetailSearchPlaceholder: '部门名称 / 部门ID',
    detailSearchPlaceholder: '部门名称 / 部门ID',
    triggerSync: (params) => syncAllSubDeptToTb(params),
    syncItem: (params) => syncTbDeptItem(params),
    deleteItem: (params) => deleteTbDeptItem(params),
    clearLocalItem: (params) => clearLocalTbDeptIdItem(params),
    getDetailItemId: (row) => row.departmentId,
    getLogPage: getTbDeptSyncLogPage,
    getLog: getTbDeptSyncLog,
    getDetailPage: getTbDeptSyncLogDetailPage,
    deleteLog: deleteTbDeptSyncLog,
    retryFailed: (params) => retryTbDeptSyncFailed(params),
    getRetryableDetailIds: (params) => getTbDeptSyncRetryableDetailIds(params),
    getStatsDetailPage: getTbDeptDetailPage,
    statsDetailColumns: buildStatsDetailColumns([
      { prop: 'departmentName', label: '部门名称', minWidth: 110 },
      { prop: 'deptOrgType', label: '类型', minWidth: 64, align: 'center', headerAlign: 'center' },
      { prop: 'departmentId', label: '部门ID', minWidth: 180 },
      { prop: 'tbThirdPartId', label: '天波部门ID', minWidth: 80 },
    ]),
    normalizeStatsDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      const rawOrgType = g('deptOrgType', 'DeptOrgType');
      return {
        id: g('id', 'Id'),
        departmentId: g('departmentId', 'DepartmentId'),
        departmentName: g('departmentName', 'DepartmentName'),
        deptOrgType: formatDeptOrgTypeLabel(rawOrgType),
        isSchoolRoot: String(rawOrgType || '').toLowerCase() === 'school',
        tbThirdPartId: g('tbThirdPartId', 'TbThirdPartId'),
        isSynced: !!(g('isSynced', 'IsSynced')),
      };
    },
    confirmMessage: '确认将「{name}」及其上级链路（如需）、子部门同步到天波平台吗？',
    clearLocalConfirmMessage: '将清除「{name}」范围内<strong>本地</strong>部门天波ID（<strong>不会</strong>调用天波删除，且<strong>不清除学校根组织ID</strong>）。<br/><span style="color:#b45309">请先确认已在天波后台手动删除对应部门</span>，否则天波仍保留原部门，再同步会按新增处理，天波侧可能出现重复部门。是否继续？',
    clearLocalItemConfirmMessage: '将清除该条<strong>本地</strong>部门天波ID（<strong>不会</strong>调用天波删除）。<br/><span style="color:#b45309">请先确认已在天波后台手动删除该部门</span>，否则天波仍保留原部门，再同步会按新增处理，天波侧可能出现重复部门。是否继续？',
    triggerClearLocal: (params) => clearLocalTbDeptIds(params),
    skipHint: '',
    detailColumns: buildSyncLogDetailColumns([
      { prop: 'departmentName', label: '部门名称', minWidth: 100 },
      { prop: 'operation', label: '操作', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'departmentId', label: '部门ID', minWidth: 160 },
      { prop: 'tbDeptId', label: '天波部门ID', minWidth: 80 },
    ]),
    normalizeDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        id: g('id', 'Id'),
        departmentId: g('departmentId', 'DepartmentId'),
        departmentName: g('departmentName', 'DepartmentName'),
        operation: g('operation', 'Operation'),
        isSuccess: !!(g('isSuccess', 'IsSuccess')),
        tbDeptId: g('tbDeptId', 'TbDeptId'),
        resultMessage: g('resultMessage', 'ResultMessage'),
      };
    },
  },
  student: {
    label: '学生',
    deptColumnLabel: '班级',
    statsDetailSearchPlaceholder: '姓名 / 学号 / 班级',
    detailSearchPlaceholder: '姓名 / 学号 / 班级',
    triggerSync: (params) => syncAllSubDeptStudentToTb(params),
    syncItem: (params) => syncTbStudentItem(params),
    deleteItem: (params) => deleteTbStudentItem(params),
    clearLocalItem: (params) => clearLocalTbStudentIdItem(params),
    getDetailItemId: (row) => row.studentId,
    getLogPage: getTbStudentSyncLogPage,
    getLog: getTbStudentSyncLog,
    getDetailPage: getTbStudentSyncLogDetailPage,
    deleteLog: deleteTbStudentSyncLog,
    retryFailed: (params) => retryTbStudentSyncFailed(params),
    getRetryableDetailIds: (params) => getTbStudentSyncRetryableDetailIds(params),
    getStatsDetailPage: getTbStudentDetailPage,
    statsDetailColumns: buildStatsDetailColumns([
      { prop: 'stuName', label: '姓名', minWidth: 80 },
      { prop: 'stuCode', label: '学号', minWidth: 72 },
      { prop: 'departmentName', label: '班级', minWidth: 96 },
      { prop: 'studentId', label: '学生ID', minWidth: 180 },
      { prop: 'tbThirdPartId', label: '天波学生ID', minWidth: 80 },
    ]),
    normalizeStatsDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        studentId: g('studentId', 'StudentId'),
        stuName: g('stuName', 'StuName'),
        stuCode: g('stuCode', 'StuCode'),
        departmentName: g('departmentName', 'DepartmentName'),
        tbThirdPartId: g('tbThirdPartId', 'TbThirdPartId'),
        isSynced: !!(g('isSynced', 'IsSynced')),
      };
    },
    confirmMessage: "确认要同步当前节点及子部门下的学生到天波平台吗？<br/><span style='color:red'>请确认已经同步架构！</span>",
    deleteConfirmMessage: '确认从天波批量删除当前范围内已同步的学生吗？<br/>仅删除<strong>天波侧数据</strong>并清除<strong>本地天波 ID</strong>，本地学生/家长数据保留；将级联删除关联家长。',
    clearLocalConfirmMessage: '将清除「{name}」范围内学生的<strong>本地天波ID</strong>（<strong>不会</strong>调用天波删除）。<br/><span style="color:#b45309">请先确认已在天波后台手动删除对应学生</span>，否则天波仍保留原人员，再同步会按新增处理，天波侧可能出现重复人员。是否继续？',
    clearLocalItemConfirmMessage: '将清除该学生<strong>本地天波ID</strong>（<strong>不会</strong>调用天波删除）。<br/><span style="color:#b45309">请先确认已在天波后台手动删除该学生</span>，否则天波仍保留原人员，再同步会按新增处理，天波侧可能出现重复人员。是否继续？',
    skipHint: '（部门未配天波ID时的在读学生数）',
    triggerDelete: (params) => deleteSubDeptStudentFromTb(params),
    triggerClearLocal: (params) => clearLocalTbStudentIds(params),
    detailColumns: buildSyncLogDetailColumns([
      { prop: 'studentName', label: '姓名', minWidth: 72 },
      { prop: 'stuCode', label: '学号', minWidth: 72 },
      { prop: 'departmentName', label: '班级', minWidth: 88 },
      { prop: 'operation', label: '操作', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'studentId', label: '学生ID', minWidth: 160 },
      { prop: 'tbStudentId', label: '天波学生ID', minWidth: 80 },
    ]),
    normalizeDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        id: g('id', 'Id'),
        studentId: g('studentId', 'StudentId'),
        studentName: g('studentName', 'StudentName'),
        stuCode: g('stuCode', 'StuCode'),
        departmentName: g('departmentName', 'DepartmentName'),
        operation: g('operation', 'Operation'),
        isSuccess: !!(g('isSuccess', 'IsSuccess')),
        tbStudentId: g('tbStudentId', 'TbStudentId'),
        resultMessage: g('resultMessage', 'ResultMessage'),
      };
    },
  },
  teacher: {
    label: '教师',
    deptColumnLabel: '部门',
    statsDetailSearchPlaceholder: '姓名 / 工号 / 部门',
    detailSearchPlaceholder: '姓名 / 部门',
    triggerSync: (params) => syncAllSubDeptTeacherToTb(params),
    syncItem: (params) => syncTbTeacherItem(params),
    deleteItem: (params) => deleteTbTeacherItem(params),
    clearLocalItem: (params) => clearLocalTbTeacherIdItem(params),
    getDetailItemId: (row) => row.teacherId,
    getLogPage: getTbTeacherSyncLogPage,
    getLog: getTbTeacherSyncLog,
    getDetailPage: getTbTeacherSyncLogDetailPage,
    deleteLog: deleteTbTeacherSyncLog,
    retryFailed: (params) => retryTbTeacherSyncFailed(params),
    getRetryableDetailIds: (params) => getTbTeacherSyncRetryableDetailIds(params),
    getStatsDetailPage: getTbTeacherDetailPage,
    statsDetailColumns: buildStatsDetailColumns([
      { prop: 'teacherName', label: '姓名', minWidth: 80 },
      { prop: 'workNumber', label: '工号', minWidth: 72 },
      { prop: 'departmentName', label: '部门', minWidth: 96 },
      { prop: 'teacherId', label: '教师ID', minWidth: 180 },
      { prop: 'tbThirdPartId', label: '天波教师ID', minWidth: 80 },
    ]),
    normalizeStatsDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        teacherId: g('teacherId', 'TeacherId'),
        teacherName: g('teacherName', 'TeacherName'),
        workNumber: g('workNumber', 'WorkNumber'),
        departmentName: g('departmentName', 'DepartmentName'),
        tbThirdPartId: g('tbThirdPartId', 'TbThirdPartId'),
        isSynced: !!(g('isSynced', 'IsSynced')),
      };
    },
    confirmMessage: '确认将当前节点及子部门下的教师同步到天波平台吗？',
    deleteConfirmMessage: '确认从天波批量删除当前范围内已同步的教师吗？<br/>仅删除<strong>天波侧数据</strong>并清除<strong>本地天波 ID</strong>，本地教师数据保留。',
    clearLocalConfirmMessage: '将清除「{name}」范围内教师的<strong>本地天波ID</strong>（<strong>不会</strong>调用天波删除）。<br/><span style="color:#b45309">请先确认已在天波后台手动删除对应教师</span>，否则天波仍保留原人员，再同步会按新增处理，天波侧可能出现重复人员。是否继续？',
    clearLocalItemConfirmMessage: '将清除该教师<strong>本地天波ID</strong>（<strong>不会</strong>调用天波删除）。<br/><span style="color:#b45309">请先确认已在天波后台手动删除该教师</span>，否则天波仍保留原人员，再同步会按新增处理，天波侧可能出现重复人员。是否继续？',
    skipHint: '',
    triggerDelete: (params) => deleteSubDeptTeacherFromTb(params),
    triggerClearLocal: (params) => clearLocalTbTeacherIds(params),
    detailColumns: buildSyncLogDetailColumns([
      { prop: 'teacherName', label: '姓名', minWidth: 72 },
      { prop: 'departmentName', label: '部门', minWidth: 88 },
      { prop: 'operation', label: '操作', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'teacherId', label: '教师ID', minWidth: 160 },
      { prop: 'tbTeacherId', label: '天波教师ID', minWidth: 80 },
    ]),
    normalizeDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        id: g('id', 'Id'),
        teacherId: g('teacherId', 'TeacherId'),
        teacherName: g('teacherName', 'TeacherName'),
        departmentName: g('departmentName', 'DepartmentName'),
        operation: g('operation', 'Operation'),
        isSuccess: !!(g('isSuccess', 'IsSuccess')),
        tbTeacherId: g('tbTeacherId', 'TbTeacherId'),
        resultMessage: g('resultMessage', 'ResultMessage'),
      };
    },
  },
  parent: {
    label: '家长',
    deptColumnLabel: '学生',
    statsDetailSearchPlaceholder: '家长姓名 / 手机号 / 学生姓名',
    detailSearchPlaceholder: '家长姓名 / 手机号 / 学生姓名',
    triggerSync: (params) => syncAllSubDeptParentToTb(params),
    syncItem: (params) => syncTbParentItem(params),
    deleteItem: (params) => deleteTbParentItem(params),
    clearLocalItem: (params) => clearLocalTbParentMappingItem(params),
    getDetailItemId: (row) => row.studentParentId,
    getLogPage: getTbParentSyncLogPage,
    getLog: getTbParentSyncLog,
    getDetailPage: getTbParentSyncLogDetailPage,
    deleteLog: deleteTbParentSyncLog,
    retryFailed: (params) => retryTbParentSyncFailed(params),
    getRetryableDetailIds: (params) => getTbParentSyncRetryableDetailIds(params),
    getStatsDetailPage: getTbParentDetailPage,
    statsDetailColumns: buildStatsDetailColumns([
      { prop: 'parentName', label: '家长姓名', minWidth: 80 },
      { prop: 'phone', label: '手机号', minWidth: 100 },
      { prop: 'studentName', label: '学生', minWidth: 72 },
      { prop: 'relationDesc', label: '关系', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'studentParentId', label: '家长ID', minWidth: 160 },
      { prop: 'tbParentId', label: '天波家长ID', minWidth: 80 },
    ]),
    normalizeStatsDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        studentParentId: g('studentParentId', 'StudentParentId'),
        parentName: g('parentName', 'ParentName'),
        phone: g('phone', 'Phone'),
        studentName: g('studentName', 'StudentName'),
        relationDesc: g('relationDesc', 'RelationDesc'),
        tbParentId: g('tbParentId', 'TbParentId'),
        isSynced: !!(g('isBound', 'IsBound') || g('isSynced', 'IsSynced')),
      };
    },
    confirmMessage: "确认要同步当前节点及子部门下的家长到天波平台吗？<br/><span style='color:red'>请确认学生已同步，且无手机号的家长将自动跳过。</span>",
    deleteConfirmMessage: '确认从天波批量删除当前范围内已同步的家长吗？<br/>仅删除<strong>天波侧数据</strong>并清除<strong>映射记录</strong>，本地家长数据保留。',
    clearLocalConfirmMessage: '将清除「{name}」范围内家长的<strong>本地天波映射</strong>（<strong>不会</strong>调用天波删除）。<br/><span style="color:#b45309">请先确认已在天波后台手动删除对应家长</span>，否则天波仍保留原数据，再同步会按新增处理，天波侧可能出现重复家长。是否继续？',
    clearLocalItemConfirmMessage: '将清除该家长<strong>本地天波映射</strong>（<strong>不会</strong>调用天波删除）。<br/><span style="color:#b45309">请先确认已在天波后台手动删除该家长</span>，否则天波仍保留原数据，再同步会按新增处理，天波侧可能出现重复家长。是否继续？',
    skipHint: '（学生未同步或无手机号的家长）',
    triggerDelete: (params) => deleteSubDeptParentFromTb(params),
    triggerClearLocal: (params) => clearLocalTbParentMappings(params),
    detailColumns: buildSyncLogDetailColumns([
      { prop: 'parentName', label: '家长姓名', minWidth: 72 },
      { prop: 'phone', label: '手机号', minWidth: 96 },
      { prop: 'studentName', label: '学生', minWidth: 72 },
      { prop: 'operation', label: '操作', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'studentParentId', label: '家长ID', minWidth: 140 },
      { prop: 'tbParentId', label: '天波家长ID', minWidth: 80 },
    ]),
    normalizeDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        id: g('id', 'Id'),
        studentParentId: g('studentParentId', 'StudentParentId'),
        parentName: g('parentName', 'ParentName'),
        phone: g('phone', 'Phone'),
        studentName: g('studentName', 'StudentName'),
        relationDesc: g('relationDesc', 'RelationDesc'),
        operation: g('operation', 'Operation'),
        isSuccess: !!(g('isSuccess', 'IsSuccess')),
        tbParentId: g('tbParentId', 'TbParentId'),
        resultMessage: g('resultMessage', 'ResultMessage'),
      };
    },
  },
};

/** 兼容 PascalCase / camelCase 的主记录归一化 */
export function normalizeTbSyncLogPayload(r) {
  if (!r) return null;
  const g = (a, b) => (r[a] !== undefined && r[a] !== null ? r[a] : r[b]);
  return {
    id: g('id', 'Id'),
    rootDepartmentId: g('rootDepartmentId', 'RootDepartmentId'),
    rootDepartmentName: g('rootDepartmentName', 'RootDepartmentName'),
    status: Number(g('status', 'Status')),
    successCount: g('successCount', 'SuccessCount') || 0,
    failCount: g('failCount', 'FailCount') || 0,
    skipCount: g('skipCount', 'SkipCount') || 0,
    startTime: g('startTime', 'StartTime'),
    endTime: g('endTime', 'EndTime'),
    errorMessage: g('errorMessage', 'ErrorMessage'),
    triggerUserId: g('triggerUserId', 'TriggerUserId'),
    triggerUserName: g('triggerUserName', 'TriggerUserName'),
  };
}

/** 解析同步开始时间用于冷却期计算 */
export function parseSyncStartTime(startTime) {
  if (!startTime) return null;
  const normalized = String(startTime).replace(/-/g, '/');
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** 计算冷却剩余秒数；进行中返回 -1 */
export function calcCooldownRemainSeconds(latestLog) {
  if (!latestLog) return 0;
  if (Number(latestLog.status) === 0) return -1;
  const start = parseSyncStartTime(latestLog.startTime);
  if (!start) return 0;
  const remainMs = TB_SYNC_COOLDOWN_MINUTES * 60 * 1000 - (Date.now() - start.getTime());
  return remainMs > 0 ? Math.ceil(remainMs / 1000) : 0;
}

export function formatCooldownText(remainSeconds) {
  if (remainSeconds === -1) return '同步进行中，请稍候';
  if (remainSeconds <= 0) return '';
  const m = Math.floor(remainSeconds / 60);
  const s = remainSeconds % 60;
  if (m > 0) return `${m} 分 ${s} 秒后可再次同步`;
  return `${s} 秒后可再次同步`;
}
